<template>
  <div class="sign-page">
    <AppNavigation />
    
    <section class="event-hero">
      <div class="container">
        <div class="row justify-content-center text-center">
          <div class="col-lg-10" data-aos="fade-up">
            <h1 class="display-4 font-weight-bold mb-4">SIGN: DC 2026</h1>
            <p class="lead mb-5">Sankoree Institute of Global Negotiators - Washington D.C. Event Registration</p>
          </div>
        </div>
      </div>
    </section>

    <section class="registration-section pb-5">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-8" data-aos="zoom-in" data-aos-delay="200">
            <div class="iframe-container shadow-lg">
              <iframe
                src="https://luma.com/embed/event/evt-jGsroPhD6HSDudT/simple"
                width="100%"
                height="700"
                frameborder="0"
                style="border: 1px solid #bfcbda88; border-radius: 8px;"
                allow="fullscreen; payment"
                aria-hidden="false"
                tabindex="0"
              ></iframe>
            </div>
            <div class="text-center mt-4">
              <p class="text-muted small">Having trouble? <a href="https://luma.com/event/evt-jGsroPhD6HSDudT" target="_blank" rel="noopener">Open registration in a new tab</a></p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <AppFooter />
  </div>
</template>

<script>
import AppNavigation from "@/components/AppNavigation.vue";
import AppFooter from "@/components/AppFooter.vue";

export default {
  name: "SignDc2026",
  components: {
    AppNavigation,
    AppFooter
  },
  mounted() {
    window.scrollTo(0, 0);
  }
};
</script>

<style scoped>
.sign-page {
  background-color: #f8f9fa;
  min-height: 100vh;
}

.event-hero {
  padding: 160px 0 60px;
  background: linear-gradient(135deg, #fff 0%, #f0f0f0 100%);
}

.event-hero h1 {
  font-family: 'Outfit', sans-serif;
  color: #c40505;
  letter-spacing: -1px;
}

.event-hero .lead {
  font-family: 'Outfit', sans-serif;
  color: #666;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
}

.iframe-container {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
}

@media (max-width: 768px) {
  .event-hero {
    padding: 120px 0 40px;
  }
  
  .event-hero h1 {
    font-size: 2.5rem;
  }
}
</style>
